import React from 'react'
import './SubHeader.css';
import {useState} from "react";
import { useStateValue } from './StateProvider';

function SubHeader() {
    const[{basket,addresses,user,blur},dispatch]=useStateValue();
    const[istrue,setIstrue]=useState(false);
    const handleClickall=()=>{
        setIstrue(!istrue);
        dispatch({
            type:'SET_BLUR',
            blur:!blur
        })
    }

  return (
      <>
      <div className='subheader'>
            <div onClick={handleClickall} className="all ele">
                    <div className="first">
                        <div>_</div>
                        <div>_</div>
                        <div>_</div>
                    </div>
                    <div className='second'>All</div>
            </div>

            <div className="giftidea ele">
                Gift Idea
            </div>
            <div className="giftcard ele">
                Gift Cards
            </div>
            <div className="buyagain ele">
                Buy Again
            </div>
            <div className="homeimprovement ele">
                Home Improvement
            </div>
            <div className="grocery ele">
                Grocery Gormet & Food
            </div>
            <div className="toygames ele">
                Toy & Games
            </div>
            <div className="homeandkitchen ele">
                Home & kitchen
            </div>
            <div className="baby ele">
                Baby
            </div>
            <div className='Amazon-pay ele'>
                Amazon Pay
            </div>  
   </div>
   </>
  )
}
export default SubHeader